import { useEffect, useContext } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import {
  MemberIdCard,
  Authorizations,
  EnrollInBenefits,
  PlanDocuments,
  CoveredEligibleMembers,
  MyPlan,
  TreatmentEstimateCosts,
  PharmacyClaims,
  MedicalClaims,
  Benefits,
  FormAndDocument,
  Dashboard,
  AuthorizationDetails,
  MedicalClaimsDetails,
  ViewTaxSummary,
  ContactUs,
  Profile,
  MemberProfile,
  VirtualVisitCare,
  PharmacyTools,
  PhysicalTherapy,
  PayYourSentaraBill,
  WellnessPrograms,
  HingeHealth,
  SuperMedicalClaims,
  SuperClaimsDetails,
  SuperEOBClaims,
  SuperRelatedClaims,
  PayMonthlyPremium,
  InterimView,
  CSRProxy
} from 'pages';
import { RequireAuth, NavigateConst } from 'common';
import { GlobalContext } from 'context';
const SideMenuRoutes = () => {
  const navigate = useNavigate();
  const getEOBURL = () => window.location.pathname?.toLowerCase().includes('home/claims-summary/');
  const { ssoEndPoints, getFeature } = useContext(GlobalContext);

  useEffect(() => {
    const eobURL = getEOBURL();
    if (eobURL) {
      navigate(NavigateConst.medicalClaimsURL);
    }
  }, [getEOBURL(), ssoEndPoints, navigate]);

  return (
    <Routes>
      <Route path={NavigateConst.signIn} element={<Dashboard />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.csrProxyForm}
        element={
          <RequireAuth>
            <CSRProxy />
          </RequireAuth>
        }
      />
      <Route
        path="/home/your-plan"
        element={
          <RequireAuth>
            <MyPlan />
          </RequireAuth>
        }
      />
      <Route
        path="/home/benefits"
        element={
          <RequireAuth>
            <Benefits />
          </RequireAuth>
        }
      />
      <Route
        path="/home/contact-us"
        element={
          <RequireAuth>
            <ContactUs />
          </RequireAuth>
        }
      />
      <Route
        path="/home/plan-documents"
        element={
          <RequireAuth>
            <PlanDocuments />
          </RequireAuth>
        }
      />
      <Route
        path="/home/covered-eligible-members"
        element={
          <RequireAuth>
            <CoveredEligibleMembers />
          </RequireAuth>
        }
      />
      <Route
        path="/home/enroll-benefits"
        element={
          <RequireAuth>
            <EnrollInBenefits />
          </RequireAuth>
        }
      />
      <Route
        path="/home/wellness-programs"
        element={
          <RequireAuth>
            <WellnessPrograms />
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.memberProfile}
        element={
          <RequireAuth>
            <MemberProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/home/forms-and-documents"
        element={
          <RequireAuth>
            <FormAndDocument />
          </RequireAuth>
        }
      />
      <Route
        path="/home/member-id-card"
        element={
          <RequireAuth>
            <MemberIdCard />
          </RequireAuth>
        }
      />
      <Route path="/home/authorizations" element={<Authorizations />} />
      <Route
        path="/home/view-tax-summary"
        element={
          <RequireAuth>
            <ViewTaxSummary />
          </RequireAuth>
        }
      />
      <Route
        path="/home/authorizations/authorizationDetails"
        element={
          <RequireAuth>
            <AuthorizationDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/home/costs-calculate"
        element={
          <RequireAuth>
            <TreatmentEstimateCosts />
          </RequireAuth>
        }
      />
      <Route
        path="/home/pharmacy-claims"
        element={
          <RequireAuth>
            <PharmacyClaims />
          </RequireAuth>
        }
      />
      <Route
        path="/home/pay-monthly-premium"
        element={
          <RequireAuth>
            <PayMonthlyPremium />
          </RequireAuth>
        }
      />
      <Route
        path="/home/pay-your-sentara-bill"
        element={
          <RequireAuth>
            <PayYourSentaraBill />
          </RequireAuth>
        }
      />
      <Route
        path="/home/medical-claims"
        element={
          <RequireAuth>
            {getFeature?.SuperEOBMedicalClaims ? <SuperMedicalClaims /> : <MedicalClaims />}
          </RequireAuth>
        }
      />
      <Route
        path="/home/behavioral-claims"
        element={
          <RequireAuth>
            {getFeature?.SuperEOBMedicalClaims ? <SuperMedicalClaims /> : <MedicalClaims />}
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.claimsSummary}
        element={
          <RequireAuth>
            {getFeature?.SuperEOBMedicalClaims ? <SuperClaimsDetails /> : <MedicalClaimsDetails />}
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.superRelatedClaims}
        element={
          <RequireAuth>
            <SuperRelatedClaims />
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.superEOBClaims}
        element={
          <RequireAuth>
            <SuperEOBClaims />
          </RequireAuth>
        }
      />
      <Route
        path={`${NavigateConst.claimsSummary}${"/:claimToken/:claimType/:isEOB/:isToken/:memberSuffix"}`}
        element={
          <RequireAuth>
            <MedicalClaimsDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        path="/home/virtual-visit-care"
        element={
          <RequireAuth>
            <VirtualVisitCare />
          </RequireAuth>
        }
      />
      <Route
        path="/home/pharmacy-tools"
        element={
          <RequireAuth>
            <PharmacyTools />
          </RequireAuth>
        }
      />
      <Route
        path="/home/physical-therapy"
        element={
          <RequireAuth>
            <PhysicalTherapy />
          </RequireAuth>
        }
      />
      <Route
        path="/home/hinge-health"
        element={
          <RequireAuth>
            <HingeHealth />
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.findADoctor}
        element={
          <RequireAuth>
            <InterimView type="findadoc" />
          </RequireAuth>
        }
      />
      <Route
        path={NavigateConst.changePCP}
        element={
          <RequireAuth>
            <InterimView type="changepcp" />
          </RequireAuth>
        }
      />
    </Routes>
  );
};

export default SideMenuRoutes;
